/**
 * Daily QC (quality control) run logging — control material of known expected range run against a
 * test, server-computed PASS/FAIL. Backs /lab/qc (LabQcController).
 */
import { fetchApi } from '../client';

export interface LabQcRunInput {
  labId?: string;
  testDefinitionId?: string;
  testName: string;
  controlLevel: string;
  controlLotNumber?: string;
  expectedLow?: number;
  expectedHigh?: number;
  observedValue: number;
  unit?: string;
  correctiveAction?: string;
  notes?: string;
}

export const labQcModule = {
  list: (testName?: string) =>
    fetchApi<any[]>(`/api/lab/qc${testName ? `?testName=${encodeURIComponent(testName)}` : ''}`),

  logRun: (data: LabQcRunInput) =>
    fetchApi<any>('/api/lab/qc', { method: 'POST', body: JSON.stringify(data) }),
};
